let cacheComps = {};

const get = k => {
  return cacheComps[k] || null;
};

const add = (k, v) => {
  cacheComps[k] = { ...v };
};

const remove = k => {
  delete cacheComps[k];
};

const clear = () => {
  cacheComps = {};
};

export default {
  clear,
  get,
  add,
  remove
};
